import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { FaUsers } from "react-icons/fa";
import { GrDocumentUser } from "react-icons/gr";
import './layout.css';
import { TbReportAnalytics } from "react-icons/tb";
import { GiMoneyStack } from "react-icons/gi";

const PfManagementLayout = ({ children }) => {
  const location = useLocation();

  return (
    <div style={{marginTop:'70px',padding:'10px'}}>
      <section>
        <div className="nav-container">
          <ul className="nav-list">
            <li className="nav-item">
              <NavLink
                id="pf-management"
                className={({ isActive }) => `nav-link ${isActive || location.pathname.startsWith('/leave-report') ? 'active' : ''}`}
                to="/provident-fund-management"
              >
                <GiMoneyStack className="nav-icon" /> PF Management
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                id="pf-past-years"
                className={({ isActive }) => `nav-link ${isActive || location.pathname.startsWith('/emps-leave-reports') ? 'active' : ''}`}
                to="/pf-past-years"
              >
                <TbReportAnalytics className="nav-icon" /> Prev- Year Reports
              </NavLink>
            </li>
          </ul>
        </div>
        <div className="content">
          {children}
        </div>
      </section>
    </div>
  );
};

export default PfManagementLayout;
